// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ModalBody_modalBody__33SFV","hasVerticalScrollbar":"ModalBody_hasVerticalScrollbar__1u9pJ"};